import { Outlet } from "react-router-dom";
import { Breadcrumbs, CompressingMenu, DataGridPage } from "@synota-io/synota-shared-ui";
import { useUserLinks } from "../users/hooks/useUserLinks";

export const ServiceChargesOutlet = () => {
  const { id, menuLinks, matchedLinks } = useUserLinks();

  return (
    <DataGridPage
      actions={(maxWidth) => {
        return <CompressingMenu primaryActions={menuLinks} maxWidth={maxWidth} />;
      }}
      title={id && <Breadcrumbs links={matchedLinks} />}
    >
      <Outlet />
    </DataGridPage>
  );
};
